module.exports = __webpack_public_path__ + "img/metinvest.31902e52.jpg";